import AppFadeView from "@toothfairy/shared-ui/AppFadeView";
import AppForms from "@toothfairy/shared-ui/AppForms";
import AppMenu from "@toothfairy/shared-ui/AppMenu";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import Constants from "../../../Constants";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "react-native";
import ToothFairyButton from "../../../Components/ToothFairyComponents/ToothFairyButton";
import IdCopyView from "../../../Components/ToothFairyComponents/IdCopyView";
import { isLargeScreen } from "../../MainViewContainer";
import SupportDateLeaf from "../SubComponents/SupportDateLeaf";

const MAX_LOGABLE_HOURS = 8;

const SupportEditScreen = ({
  log = null,
  isSaving = false,
  isDeleting = false,
  onSave = () => {},
  onDelete = () => {},
  navigateBack = () => {},
}) => {
  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();

  const supportSchema = AppForms.yup.object().shape({
    supportHours: AppForms.yup
      .number()
      .min(0.5, t("admin.support.validation.hoursMin"))
      .required(t("admin.support.validation.hoursRequired")),
    description: AppForms.yup
      .string()
      .required(t("admin.support.validation.descriptionRequired")),
  });

  if (!log) return null;

  return (
    <AppFadeView
      style={{
        horizontalMargin: 10,
        paddingHorizontal: 20,
        minWidth: isLargeScreen() ? 450 : 300,
        paddingBottom: 10,
        overflow: "auto",
      }}
    >
      <AppMenu.DefaultBackOptionComponent
        navigateBack={navigateBack}
        isClickable
        isBackIconDisplayed
        sectionTitle={`${t("admin.support.editTitle")}: ${
          log?.createdBy || log?.userID || ""
        }`}
      />
      {log?.id && <IdCopyView id={log?.id} />}

      <AppForms.AppForm
        key={log?.id}
        initialValues={{
          supportHours: log?.supportHours || 0.5,
          description: log?.description || "",
          activityDate: log?.creationTime
            ? dayjs(log.creationTime * 1000).toISOString()
            : dayjs().startOf("day").toISOString(),
        }}
        enableReinitialize
        onSubmit={onSave}
        validationSchema={supportSchema}
      >
        <SupportDateLeaf label={t("admin.support.form.dateLabel")} />
        <AppForms.AppFormTrackSlider
          containerStyle={{
            marginTop: 10,
          }}
          step={0.5}
          minimumValue={0.5}
          maximumValue={Math.max(MAX_LOGABLE_HOURS, log?.supportHours || 0.5)}
          unitLabel={" h"}
          label={t("admin.support.form.hoursLabel")}
          name="supportHours"
          isMandatory
        />
        <AppForms.AppFormField
          showTextInputLabel
          wrapperInputStyle={{
            height: 150,
            marginBottom: 10,
            padding: 5,
          }}
          textContainer={{
            padding: 10,
            marginHorizontal: 0,
            minHeight: 120,
          }}
          multiline
          isMandatory
          label={t("admin.support.form.descriptionLabel")}
          placeholder={t("admin.support.form.descriptionPlaceholder")}
          keyboardtype="default"
          textContextType="label"
          autoCorrect={false}
          name="description"
        />
        <View style={{ alignItems: "center" }}>
          <AppForms.AppSubmitButton
            title={t("admin.support.form.update")}
            isDisabled={isSaving}
            awesomeIconColor={currentTheme?.theme?.white}
            backgroundColor={currentTheme?.theme?.primary}
            btnContentStyle={{
              paddingLeft: 0,
              paddingRight: 0,
            }}
            style={[
              {
                height: Constants.appButtonHeight,
                width: "auto",
                shadowColor: currentTheme?.theme?.transparent,
                marginHorizontal: 10,
              },
            ]}
            wrapperStyle={[
              {
                width: "fit-content",
                minWidth: 150,
                marginTop: 20,
                height: Constants.appButtonHeight,
              },
            ]}
          />
          <ToothFairyButton
            title={t("admin.support.form.deleteEntry")}
            onPress={onDelete}
            isDeletion
            isDisabled={isDeleting}
            wrapperStyle={{
              marginTop: 30,
              minWidth: 150,
              height: Constants.appButtonHeight,
            }}
          />
        </View>
      </AppForms.AppForm>
    </AppFadeView>
  );
};

export default SupportEditScreen;